import { FormHelperText, FormLabel, styled } from '@mui/material';
import { WarningCircle } from '@phosphor-icons/react';

export const FormLabelStyled = styled('label')(({ theme }) => ({
  ...theme.typography.label,
  color: theme.palette.grey[400],
  '&.Mui-disabled': {
    color: theme.palette.grey[400],
  },
  '&.Mui-focused': {
    color: theme.palette.grey[400],
  },
  '&.Mui-error': {
    color: theme.palette.grey[400],
  },
})) as typeof FormLabel;

export const FormHelperTextWrapperStyled = styled(FormHelperText)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[400],
    marginLeft: 0,
    marginTop: 0,
    '&.Mui-disabled': {
      color: theme.palette.grey[400],
    },
    '&.Mui-focused': {
      color: theme.palette.grey[400],
    },
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
  })
) as typeof FormHelperText;

export const ErrorOutlineIconStyled = styled(WarningCircle)({
  fontSize: '2rem',
});
